import React, { useCallback, useState } from 'react';
import api from 'services';
import { useNewToast } from 'hooks/newToast';

import { appWarnings } from 'utils/appWarnings';

export const useCadSecador = () => {
  const { showToast } = useNewToast();

  const [secadores, setSecadores] = React.useState([]);
  const [secadoresLoading, setSecadoresLoading] = React.useState(false);

  const [deleteSecadorLoading, setDeleteSecadorLoading] = React.useState(false);
  const [addSecadorLoading, setAddSecadorLoading] = React.useState(false);

  const [editSecadorLoading, setEditSecadorLoading] = useState(false);

  const getSecadores = useCallback(async filter => {
    try {
      setSecadoresLoading(true);
      const response = await api.cadSecador().getSecadores(filter);
      setSecadores(response);
    } catch (errors) {
    } finally {
      setSecadoresLoading(false);
    }
  }, []);

  const addSecador = useCallback(
    async ({ descricao, codigo, capacidade }) => {
      try {
        setAddSecadorLoading(true);
        const dados = {
          descricao,
          codigo: codigo.codigo,
          capacidade: Number(capacidade),
        };
        const response = await api.cadSecador().addSecador(dados);
        showToast({
          type: 'success',
          message: 'Secador adicionado com sucesso!',
        });
        return response;
      } catch (err) {
        showToast(appWarnings.Danger(err));
        throw new Error(err);
      } finally {
        setAddSecadorLoading(false);
      }
    },
    [showToast]
  );

  const editSecador = useCallback(
    async ({ id, descricao, codigo, capacidade }) => {
      try {
        setEditSecadorLoading(true);
        const dados = {
          descricao,
          codigo: codigo.codigo,
          capacidade,
        };
        await api.cadSecador().editSecador(id, dados);
        showToast({
          type: 'success',
          message: 'Secador editado com sucesso!',
        });
      } catch (err) {
        showToast(appWarnings.Danger(err));
        throw new Error(err);
      } finally {
        setEditSecadorLoading(false);
      }
    },
    [showToast]
  );

  const deleteSecador = useCallback(
    async id => {
      try {
        setDeleteSecadorLoading(true);
        await api.cadSecador().deleteSecador(id);
        showToast({
          type: 'success',
          message: 'Secador excluído com sucesso!',
        });
      } catch (err) {
        showToast(appWarnings.Danger(err));
        throw new Error(err);
      } finally {
        setDeleteSecadorLoading(false);
      }
    },
    [showToast]
  );

  return {
    getSecadores,
    secadores,
    addSecador,
    editSecador,
    deleteSecador,
    secadoresLoading,
    addSecadorLoading,
    editSecadorLoading,
    deleteSecadorLoading,
  };
};
